import PropTypes from 'prop-types';
import { Header, BackButton, SpottyCat } from '@spotahome/ui-library';
import { getPagePath, useSoyuzExperiment } from '@spotahome/soyuz/client';

import HeaderContainer from '@spotahome/marketplace-common/src/components/HeaderContainer';
import ListingUnavailableModal from '@spotahome/marketplace-common/src/components/ListingUnavailableModal';

import AlternativesModal from '@spotahome/marketplace-common/src/components/AlternativesModal/AlternativesModal';

import {
  SkeletonSlider,
  SkeletonBookNow,
  SkeletonListingDetails
} from '../Skeleton';

const RentableUnitNotFound = ({
  cityInfo,
  deviceType,
  listingId,
  moveIn = '',
  moveOut = ''
}) => {
  const isShowAlternativesExperiment =
    useSoyuzExperiment('ShowAlternativesExperiment').get('behaviour') ===
    'variant';
  const handleOnSeeMoreProperties = e => {
    if (e) {
      e.preventDefault();
    }
    let destinationUrl;
    if (cityInfo?.id) {
      destinationUrl = getPagePath('marketplace.search', {
        params: {
          city: cityInfo.id
        }
      });
    } else {
      destinationUrl = getPagePath('landing');
    }
    window.location.href = destinationUrl;
  };

  const handleBackClick = e => {
    if (e) {
      e.preventDefault();
    }

    if (typeof window !== 'undefined') {
      handleOnSeeMoreProperties();
    }
  };

  return (
    <>
      <div className="listing-header">
        <HeaderContainer />
      </div>

      <section className="l-main-section">
        {deviceType === 'smartphone' && (
          <Header
            className="listing__header"
            logo={null}
            menuIcon={
              <BackButton
                dataTest="mobile-back-button"
                onClick={handleBackClick}
                size="small"
              />
            }
          />
        )}
        <div className="listing listing--redesign">
          <div className="listing__grid-cell listing__grid-cell--no-padding">
            <SkeletonSlider />
          </div>
          <div className="listing__grid-cell listing__grid-cell--full-column">
            <SkeletonBookNow />
          </div>
          <div className="listing__grid-cell listing__grid-cell--vertical-flex listing__grid-cell--no-padding">
            <SkeletonListingDetails />
          </div>
        </div>
      </section>
      {isShowAlternativesExperiment ? (
        <AlternativesModal
          isOpen
          isClosable={false}
          listingId={listingId}
          moveIn={moveIn}
          moveOut={moveOut}
          cityId={cityInfo.id}
        />
      ) : (
        <ListingUnavailableModal
          isClosable={false}
          onClick={handleOnSeeMoreProperties}
        />
      )}
      <SpottyCat />
    </>
  );
};

RentableUnitNotFound.propTypes = {
  deviceType: PropTypes.string.isRequired,
  cityInfo: PropTypes.shape({
    id: PropTypes.string
  }).isRequired,
  listingId: PropTypes.string.isRequired,
  moveIn: PropTypes.string,
  moveOut: PropTypes.string
};

export default RentableUnitNotFound;
